import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Image,
    message
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {
    PaperClipOutlined,
    LinkOutlined,
    ExclamationCircleFilled,
    SearchOutlined,
    ReloadOutlined, DownloadOutlined, DeleteOutlined, PlusOutlined, LoadingOutlined
} from '@ant-design/icons'
import moment from 'moment';


const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {}, oldcondition: {}, list: [], tableloading: false, selectedRowKeys: [], count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/backup', ['首页', '数据备份'])
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, {[name]: dateString})
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, {current: page, pagesize: pagesize})
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Database/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.data,
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    download(id) {
        let that = this
        that.setState({
            downloading: true
        })
        // console.log(arr)
        fetch('/User/index', {
            // post提交
            method: "POST",
            body: JSON.stringify({
                id
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }
                try {
                    var elemIF = document.createElement("iframe");
                    elemIF.src = data.url;
                    elemIF.style.display = "none";
                    document.body.appendChild(elemIF);
                } catch (e) {
                    alert("下载异常！");
                }
                that.setState({
                    downloading: false
                })

            })
    }

    addBackup() {
        let that = this
        fetch('/Database/doview', {
            method: "POST",
            body: JSON.stringify({})
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }
                message.success(data.msg)
                this.pagechange(1, this.state.oldcondition.pagesize)
            })
    }

    del_item(id) {
        let that = this
        fetch('/Database/del', {
            method: "POST",
            body: JSON.stringify({
                id
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
            })
    }

    render() {
        const columns = [
            {
                title: '备份时间',
                dataIndex: 'addtime',
                key: 'addtime',
            }, {
                title: '备份内容',
                dataIndex: 'name',
                key: 'name',
            }, {
                title: '状态',
                dataIndex: 'zt',
                key: 'zt',
                width: 100,
                render: (row, record) => {
                    return (<>
                        <Tag color={'green'}>{row}</Tag>
                    </>)
                },
            }, {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                width: 100,
                render: (row, record) => {
                    return (<>
                        <Space>
                            {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('9') ?
                                <a href={record.url} download target={"_blank"}>
                                    {!this.state.downloading ? <DownloadOutlined/> : <LoadingOutlined spin/>}
                                </a>
                                : null) : null}
                            {store.getState().data.info.lmqx_sc ? (store.getState().data.info.lmqx_sc.includes('9') ?
                                <Popconfirm
                                    title="确认删除?"
                                    onConfirm={() => {
                                        this.del_item(record.id)
                                    }}
                                    onCancel={() => {
                                    }}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <a style={{color:'red'}}><DeleteOutlined/></a>
                                </Popconfirm>
                                : null) : null}
                        </Space>
                    </>)
                },
            },]
        const {tableloading, selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Row justify="space-between" align="top" style={{marginBottom: 15}}>
                <Space wrap>
                    <RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'addtime')}
                                 value={[(this.state.newcondition.addtime1 ? moment(this.state.newcondition.addtime1) : null), (this.state.newcondition.addtime2 ? moment(this.state.newcondition.addtime2) : null)]}
                                 placeholder={['开始时间', '结束时间']}/>
                    <Button type="primary" icon={<SearchOutlined/>}
                            onClick={this.getdata.bind(this, 1)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined/>} className='huise'
                            onClick={this.reset.bind(this)}>重置</Button>
                </Space>
                {store.getState().data.info.lmqx_tj ? (store.getState().data.info.lmqx_tj.includes('9') ?
                    <Popconfirm
                        title="确认创建备份?"
                        onConfirm={() => {
                            this.addBackup()
                        }}
                        onCancel={() => {
                        }}
                        okText="确定"
                        cancelText="取消"
                    >
                        <Button type="primary" icon={<PlusOutlined/>}>创建备份</Button>
                    </Popconfirm>
                    : null) : null}
            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                // rowSelection={rowSelection}
                className='table'
                // scroll={{x: 2500}}
                style={{marginBottom: 20}}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap>
                        {hasSelected ? <>

                        </> : null}
                    </Space>
                </div>
                <Pagination showQuickJumper
                            current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                            pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                            total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                            showTotal={total => `共 ${total} 条数据`}/>
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname}/>
